import { SetLiveQueueType } from "../action-types/livequeue.action.types";

export const SetLiveQueue = (message: any) => {
  return {
    type: SetLiveQueueType.SET_LIVE_QUEUE,
    payload: message,
  };
};
